<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="Close()"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Conciliação Bancária</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="Conciliar()" :disabled="!arquivo">Conciliar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-file-input v-model="arquivo" label="Arquivo" @change="CarregarDadosArquivo()" dense outlined/>
                    </v-col>
                </v-row>
                <v-divider class="py-2"/>
                <v-simple-table v-if="!isLoading" dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Conciliado</th>
                                <th class="text-left">Código</th>
                                <th class="text-left">Data</th>
                                <th class="text-left">Descrição</th>
                                <th class="text-left">Entrada</th>
                                <th class="text-left">Saída</th>
                                <th class="text-left">Descrição (Arquivo)</th>
                                <th class="text-left">Valor (Arquivo)</th>
                            </tr>
                        </thead>
                        <tbody v-if="extrato">
                            <tr v-for="item in extrato" :key="item.id">
                                <td>
                                    <v-checkbox v-if="item.idFluxoBancario > 0" v-model="item.conciliado" dense/>
                                </td>
                                <td>{{ item.idFluxoBancario }}</td>
                                <td>{{ new Date(item.data).ddmmyyyy() }}</td>
                                <td>{{ item.descricao }}</td>
                                <td>{{ item.credito ? item.credito.toMoeda() : ""}}</td>
                                <td>{{ item.debito ? item.debito.toMoeda() : "" }}</td>
                                <td>{{ item.descricaoArquivo }}</td>
                                <td>{{ item.valorArquivo }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';

export default {
    props:{
        value: {},
        filtro: {
            required: true
        }
    },
    watch: {
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (this.dialog) {
                this.Carregar();
            }
            else {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        dialog: false,
        isLoading: false,
        service: new FluxoBancarioService(),
        extrato: [],
        arquivo: null
    }),
    methods: {
        Carregar(){
            this.isLoading = true;
            this.service.ListarComFiltro(this.filtro).then(
                res => {
                    this.extrato = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() => {
                this.isLoading = false;
            });
        },
        CarregarDadosArquivo(){
            if(!this.arquivo)
                return;
            this.isLoading = true;
            this.service.LerArquivoConciliacao(this.arquivo).then(
                res => {
                    let conciliacoes = res.data.map(x => ({
                        descricao: x.descricao,
                        dataHora: new Date(x.dataHora).yyyymmdd(),
                        valor: x.valor,
                        tipo: x.tipo
                    }));
                    conciliacoes.forEach(conciliacao => {
                        let item = this.extrato.find(x => new Date(x.data).yyyymmdd() == conciliacao.dataHora && (conciliacao.tipo == 'CREDIT' ? x.credito == conciliacao.valor : x.debito == conciliacao.valor));
                        if(item){
                            item.conciliado = true;
                            item.descricaoArquivo = conciliacao.descricao;
                            item.valorArquivo = conciliacao.tipo == 'CREDIT' ? conciliacao.valor : conciliacao.valor * -1;
                        }
                        else{
                            this.extrato.push(
                                {
                                    data: conciliacao.dataHora,
                                    descricaoArquivo: conciliacao.descricao,
                                    valorArquivo: conciliacao.tipo == 'CREDIT' ? conciliacao.valor : conciliacao.valor * -1
                                }
                            )
                        }
                    });
                    setTimeout(() => {
                        this.extrato.sort(function(a, b) {
                            return new Date(a.data) - new Date(b.data);
                        })
                        this.isLoading = false;
                    }, 1000);
                },
                err => {
                    this.$swal('Aviso', err.response.data, 'error')
                }
            )
        },
        Conciliar(){
            let itens = this.extrato.filter(x => x.idFluxoBancario > 0).map(x => ({ 
                id: x.idFluxoBancario,
                conciliado: x.conciliado
            }));
            this.service.Conciliar(itens).then(
                res => {
                    this.$swal('Aviso', 'Operação realizada com sucesso!', 'success')
                    this.Close();
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            ).finally(() => this.isLoading = false)
        },        
        Close(){
            this.Clear();
            this.dialog = false;
        },
        Clear(){
            this.extrato = [];
            this.arquivo = null;
            this.isLoading = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

    }
}
</script>